import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ProtectionPlanEnrollment {
  subscriptionPlan: ProtectionPlanName | '';
  enrollmentStatus: EnrollmentStatus | '';
  subscriptionStatus: SubscriptionStatus | '';
}

interface EnrollmentSettings {
  enrollmentView: boolean;
}

export enum SubscriptionStatus {
  Current = 'Current',
  Future = 'Future',
  PendingCancellation = 'PendingCancellation',
  Cancelled = 'Cancelled',
  PendingChange = 'PendingChange',
  PendingEnrollment = 'PendingEnrollment',
}

export enum EnrollmentStatus {
  Initiated = 'Initiated',
  Completed = 'Completed',
  Cancelled = 'Cancelled',
}

export enum ProtectionPlanName {
  Free = 'Free',
  Standard = 'Standard',
  Premium = 'Premium',
  Professional = 'Professional',
  ProtectionPartnerMonitoring = 'ProtectionPartnerMonitoring',
}

interface TaxPrepEnrollment {
  taxPrepEnrollmentCompleted: boolean | undefined;
  showTaxPrepNextStepsModal: boolean | undefined;
  paymentCompleted: boolean | undefined;
}

interface EnrollmentStore {
  protectionPlanEnrollment: ProtectionPlanEnrollment | null;
  taxPrepEnrollment: TaxPrepEnrollment | null;
  setProtectionPlanEnrollment: (newEnrollment: ProtectionPlanEnrollment) => void;
  setTaxPrepEnrollment: (newEnrollment: TaxPrepEnrollment) => void;
  enrollmentSettings: EnrollmentSettings | null;
  setEnrollmentSettings: (newEnrollmentSettings: EnrollmentSettings) => void;
  clearEnrollmentStore: () => void;
}

export const useEnrollmentStore = create<EnrollmentStore>()(
  persist(
  (set) => ({
  protectionPlanEnrollment: { subscriptionPlan: '', enrollmentStatus: '',  subscriptionStatus: '' },
  taxPrepEnrollment: { taxPrepEnrollmentCompleted: false, showTaxPrepNextStepsModal: false, paymentCompleted: false },
  enrollmentSettings: { enrollmentView: false },
  setProtectionPlanEnrollment: (newEnrollment) => set({ protectionPlanEnrollment: newEnrollment }),
  setTaxPrepEnrollment: (newEnrollment) => set({ taxPrepEnrollment: newEnrollment }),
  setEnrollmentSettings: (newEnrollmentView) => set({ enrollmentSettings: newEnrollmentView }),
    clearEnrollmentStore: () => {
      set({
        protectionPlanEnrollment: null,
        taxPrepEnrollment: null,
        enrollmentSettings: null,
      });
      localStorage.removeItem('EnrollmentStore');
    },
}),
{ name: 'EnrollmentStore' }
),);

export default useEnrollmentStore;
